import AppProvider from '@/contexts';

import BasicLayout from '@/layouts/basic';
import PrivateLayout from '@/layouts/private';
import { motion, AnimatePresence } from 'framer-motion';
import type { AppProps } from 'next/app';
import { PageLayout } from '@/layouts/shared';
import { appWithTranslation } from 'next-i18next';
import GoogleAnalytics from '@/components/analytics/GoogleAnalytics';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-image-gallery/styles/css/image-gallery.css';
import 'react-contexify/dist/ReactContexify.css';

import './global.css';
import './global-partner.css';
import './consult-reels.css';

import Head from 'next/head';
import NewLayout from '@/layouts/new';

const App = ({ Component, pageProps, router }: AppProps) => {
  const { layout, isAuth, keyActive, isShowNav, isMobile, isShowBubble, platform, isShowPopup, isHideFooterMobile, appBannerOs } = pageProps as any;
  
  if (layout === PageLayout.Basic) {
    return (
      <AppProvider pageProps={pageProps}>
        <BasicLayout>
          <GoogleAnalytics />
          <Component {...pageProps} />
        </BasicLayout>
      </AppProvider>
    );
  }
  if (layout === PageLayout.Journal) {
    return (
      <AppProvider pageProps={pageProps}>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        </Head>
        <GoogleAnalytics />
        <Component {...pageProps} />
      </AppProvider>
    );
  }
  if (layout == PageLayout.New) {
    return (
      <AppProvider pageProps={pageProps}>
        <NewLayout
          platform={platform}
          isAuth={isAuth}
          keyActive={keyActive}
          isShowBubble={isShowBubble}
          isShowNav={isShowNav}
          isHideFooterMobile={isHideFooterMobile}
          isMobile={isMobile}
          isShowPopup={isShowPopup}
          appBannerOs={appBannerOs ?? null}
        >
          <>
            <Head>
              <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
              {/* Safari iOS: banner hệ thống "Mở/Tải app An Thư" */}
              <meta name="apple-itunes-app" content="app-id=1613308085" />
              {/* xác minh anthu.vn trên Bing Webmaster Tools (giữ lại, xoá là mất xác minh) */}
              <meta name="msvalidate.01" content="7FBE1FD0BB173565C745C6EF9675FB33" />
            </Head>
            <GoogleAnalytics />
            <div key={router.pathname} className="tw-h-full tw-w-full">
              <Component {...pageProps} />
            </div>
          </>
        </NewLayout>
      </AppProvider>
    );
  }
  return (
    <AppProvider pageProps={pageProps}>
      <PrivateLayout isAuth={isAuth} isMobile={isMobile}>
        <>
          <Head>
            <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
            <meta name="zalo-platform-site-verification" content="UzxYEA_KUc8fvkz9e_5hVLN7-L6viIqEC3Ws" />
          </Head>
          <GoogleAnalytics />
          <Component {...pageProps} />
        </>
      </PrivateLayout>
    </AppProvider>
  );
};

export default appWithTranslation(App);
